<template>
  <div>
    <!-- 原价计算option -->
    <el-dialog :title="$t('message.originalPriceCalculationOption')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="700px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <li class="flex05">
            </li>
            <!--附加服务名称  -->
            <li class="flex15">
              {{ $t("message.additionalServicesName") }}
            </li>
            <!--收费标准  -->
            <li>{{ $t("message.actualCharges") }}</li>
            <li></li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index">
            <!-- 附加服务选择  -->
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="changeChecked(item)"> </el-checkbox>
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              <span v-if="!item.edit">{{ item.name }}</span>
              <el-input v-else v-model="item.name"></el-input>
            </li>

            <!--收费标准  -->
            <li>
              <el-input v-model="item.price" type="number" placeholder="请输入">
                <template slot="append">
                  <span>元</span>
                </template>
              </el-input>
            </li>
            <li>
              <el-checkbox v-model="checked" v-if="item.name == '詳細検品'" @change="changeChecked(item)">自动计算单价
              </el-checkbox>
            </li>
          </ul>
          <!-- 操作 -->
          <div class="operation">
            <el-button size="mini" type="success" @click="add">
              追加自定义option
            </el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import NP from 'number-precision' //NP.strip 处理浮点数
import { mapState } from 'vuex'
export default {
  props: {
    itemDetail: { type: Object },
    i: { type: Number }
  },
  data() {
    return {
      show: false,
      NP,
      optionsList: [],
      dialogVisible: false,
      checked: true,
    };
  },
  computed: {
    ...mapState({
      detail: (state) => state.orderDetail.detail,

    }),
  },
  created() {

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.$api.orderApi.orderBulkOptionList().then((res) => {
          this.optionsList = res.data;
          if (this.itemDetail.bulk_option != false && this.itemDetail.bulk_option != null) {
            this.itemDetail.bulk_option.forEach(item2 => {
              let flag = this.optionsList.some(item => item.name == item2.name)
              if (!flag) {
                this.optionsList.push({
                  name: item2.name,
                  edit: true,
                  price: item2.price,
                  checked: true
                })
              }
              this.optionsList.forEach(item => {
                if (item.name == item2.name) {
                  item.checked = true
                  item.price = item2.price
                }
              })
            })

          }
        });
      }
    },
  },
  methods: {
    add() {
      this.optionsList.push({
        checked: false,
        name: "",
        show: true,
        edit: true
      });
    },
    // 自动计算单价
    changeChecked(item) {
      if (item.name != '詳細検品') {
        return
      }
      if (this.checked) {
        this.optionsList.forEach(item => {
          if (item.name == '詳細検品') {
            if (this.itemDetail.bulk_price > 30) {
              item.price = (this.itemDetail.bulk_price * 0.04).toFixed(2)
            } else {
              if (this.itemDetail.bulk_price > 15) {
                item.price = 1.5
              } else {
                item.price = 1
              }
            }
          }
        })
      } else {
        this.optionsList.forEach(item => {
          if (item.name == '詳細検品') {
            item.price = '0'
          }
        })
      }
    },
    // 保存
    save() {
      let options = [];
      for (let i = 0; i < this.optionsList.length; i++) {
        if (this.optionsList[i].checked) {
          if (this.optionsList[i].name == '') {
            return this.$message.error('选中的服务名称与服务价格不能为空，请检查后重新提交')
          }
          if (this.optionsList[i].name == '詳細検品') {
            if ((this.optionsList[i].price == '' || this.optionsList[i].price == 0) && !this.checked) {
              return this.$message.error(this.optionsList[i].name + '选中的服务名称与服务价格不能为空，请检查后重新提交')
            }

          } else {
            if (this.optionsList[i].price == '' || this.optionsList[i].price == 0)
              return this.$message.error(this.optionsList[i].name + '选中的服务名称与服务价格不能为空，请检查后重新提交')

          }
          let list = this.optionsList.filter(item => item.name.trim() == this.optionsList[i].name.trim())
          //只能存在一个唯一的option中文名
          // if (list.length > 1) {
          //   return this.$message.error('option中文名称不能一致可以加个（新）之类的，比如详细检品（新）')
          // }
          options.push(this.optionsList[i]);
        }
      }
      // 批量修改
      if (this.itemDetail.checked) {
        this.detail.order_detail.forEach(item => {
          if (item.checked) {
            let optionCopy = JSON.parse(JSON.stringify(options))
            item.bulk_option = optionCopy
          }
        })
      }
      this.detail.order_detail[this.i].bulk_option = options;
      this.$forceUpdate()
      let datas = {
        order_detail_id: [],
        field: 'bulk_option',
        value: options,
      }
      // 处理order_detail_id
      /**
       * 1. 如果item.checked为true，遍历所有order_detail，将所有checked为true的order_detail_id添加到datas.order_detail_id中
       * 2. 如果item.checked为false，将item.id添加到datas.order_detail_id中
       */
      if (this.itemDetail.checked) {
        this.detail.order_detail.forEach((data) => {
          if (data.checked) {
            datas.order_detail_id.push(data.id)
          }
        })
      } else {
        datas.order_detail_id.push(this.itemDetail.id)
      }
      this.$api.orderApi
        .bulkOrderSaveDetail(datas)

      this.dialogVisible = false;
    },
    // 是否输入的小数
    handleInput(value, index) {
      // 使用正则表达式来判断是否输入了小数
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('.', '');
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('-', '');
        this.optionsList[index].num = this.optionsList[index].num.replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;
  // height: 650px;
  // overflow-y: auto;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 2;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;


  .el-button {
    margin-right: 220px;
  }
}

.showList {
  transition: all 0.3s;
  height: 0;
  overflow: hidden;
}

.isShow {
  height: auto;

}
</style>